import { useUpsertIncidentStatusSummary } from 'components/IAP/hooks/incidentStatusSummaryHooks';
import { ResponderInjuriesFormFields } from 'types/iapBaseTypes';

import ResponderCountTable from './ResponderCountTable';

const ResponderInjuriesTable = ({
  statusSummaryId,
  originalResponderInjuries,
  readOnly = false,
}: {
  statusSummaryId: string;
  originalResponderInjuries: ResponderInjuriesFormFields;
  readOnly?: boolean;
}) => {
  const upsertIncidentStatusSummary =
    useUpsertIncidentStatusSummary(statusSummaryId);

  return (
    <ResponderCountTable
      label="Responder Injuries"
      testId="ics209-responder-injuries"
      thisReportingPeriodLabel="Total Responder Injuries This Reporting Period"
      totalLabel="Total Responder Injuries To Date"
      thisReportingPeriod={
        originalResponderInjuries?.responderInjuriesThisReportingPeriod ?? 0
      }
      total={originalResponderInjuries?.responderInjuriesTotal ?? 0}
      readOnly={readOnly}
      onSave={({ thisReportingPeriod, total }) =>
        upsertIncidentStatusSummary({
          responderInjuriesThisReportingPeriod: thisReportingPeriod,
          responderInjuriesTotal: total,
        })
      }
    />
  );
};

export default ResponderInjuriesTable;
